var _title, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgIconGas = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "17.5000269px",
    height: "15px",
    viewBox: "0 0 17.5000269 15",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "GasPump")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Bswap",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "swap_\\u5151\\u6362\\u52A0\\u8F7D",
    transform: "translate(-748.875000, -497.137537)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-5",
    transform: "translate(400.000000, 134.500000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-3",
    transform: "translate(24.000000, 343.137537)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "GasPump",
    transform: "translate(323.000000, 17.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.828125,5.4421875 L17.3171875,3.9328125 C17.0729741,3.68859909 16.6770259,3.68859909 16.4328125,3.9328125 C16.1885991,4.17702591 16.1885991,4.57297409 16.4328125,4.8171875 L17.9421875,6.328125 C18.0587949,6.44486076 18.1245103,6.6029709 18.125,6.76796875 L18.125,13.125 C18.125,13.470178 17.845178,13.75 17.5,13.75 C17.154822,13.75 16.875,13.470178 16.875,13.125 L16.875,10 C16.875,8.96446609 16.0355339,8.125 15,8.125 L13.75,8.125 L13.75,4.375 C13.75,3.33946609 12.9105339,2.5 11.875,2.5 L5.625,2.5 C4.58946609,2.5 3.75,3.33946609 3.75,4.375 L3.75,16.25 L2.5,16.25 C2.15482203,16.25 1.875,16.529822 1.875,16.875 C1.875,17.220178 2.15482203,17.5 2.5,17.5 L15,17.5 C15.345178,17.5 15.625,17.220178 15.625,16.875 C15.625,16.529822 15.345178,16.25 15,16.25 L13.75,16.25 L13.75,9.375 L15,9.375 C15.345178,9.375 15.625,9.65482203 15.625,10 L15.625,13.125 C15.625,14.1605339 16.4644661,15 17.5,15 C18.5355339,15 19.3750135,14.1605339 19.3750135,13.125 L19.3750135,6.76796875 C19.3768938,6.27077794 19.1800001,5.79345122 18.828125,5.4421875 Z M11.25,9.375 L6.25,9.375 C5.90482203,9.375 5.625,9.09517797 5.625,8.75 C5.625,8.40482203 5.90482203,8.125 6.25,8.125 L11.25,8.125 C11.595178,8.125 11.875,8.40482203 11.875,8.75 C11.875,9.09517797 11.595178,9.375 11.25,9.375 Z",
    id: "\\u5F62\\u72B6",
    fill: "#988EB7",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }))))))));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconGas, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon_gas.571f3f96.svg";
export { ForwardRef as ReactComponent };